import CloseIcon from "Assets/Icons/CloseIcon";
import LeftArrow from "Assets/Icons/LeftArrow";
import SliderPaneComponent from "Components/CommonComponents/SliderPaneComponent";
import MarkedLectureViewListing from "Pages/MySchedule/TOCModal/MarkedLectureViewListing";
import { useEffect, useState } from "react";
import { Button, Modal, ModalFooter } from "reactstrap";
import styled from "styled-components";
import {
  BASE_URL,
  GET_ASSETS_WITH_SM_ID,
} from "utilFunctions/Constants/urlConstants";
import { usePutPostAPI } from "utilFunctions/CustomHooks/usePutPostAPI";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { convertTime } from "utilFunctions/helperFunctions/convertTime";

export interface GetAssetsIF {
  nodeId: number | string;
  nodeTitle: string;
  marked: boolean;
  nodeType: string | null;
  enabled: boolean;
}
interface MarkedLectureViewModalIF {
  mode: string;
  isLectureViewModal: boolean;
  setIsLectureViewModal: any;
  selectedlecture: any;
  editHandler?: any;
}
const DivMarked = styled<any>("div")`
  font-weight: 700;
  font-size: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "16px" : "24px"};
  color: #333333;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "" : "0.5px solid #afafaf"};
  padding: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "" : "16px"};
`;
const MarkedLectureViewModal = ({
  mode,
  isLectureViewModal,
  setIsLectureViewModal,
  selectedlecture,
  editHandler,
}: MarkedLectureViewModalIF) => {
  const { screen }: any = useWindowSize();
  const [lectureAssetsData, setlectureAssetsData] = useState<GetAssetsIF[]>([]);
  const { makeRequest: PostGetAssets, loading: Loader } = usePutPostAPI(
    (data: any) => {
      if (data["data"] && data["data"] && data["data"]["nodesList"].length) {
        setlectureAssetsData(data["data"]["nodesList"]);
      } else {
        setlectureAssetsData([]);
      }
    },
    (error) => {
      setlectureAssetsData([]);
      console.log(error);
    },
    "Post"
  );
  useEffect(() => {
    if (
      Object.keys(selectedlecture).length &&
      (selectedlecture.revisionRank == null ||
        parseInt(selectedlecture.revisionRank) == 0)
    ) {
      const url = BASE_URL + GET_ASSETS_WITH_SM_ID;
      const obj = {
        lectureId: selectedlecture?.fexRecordId,
      };
      PostGetAssets(url, obj);
    } else {
      setlectureAssetsData([
        {
          nodeTitle:
            "Revision Lecture " + selectedlecture.revisionRank + " marked",
          nodeId: "revision_" + selectedlecture.revisionRank,
          nodeType: null,
          marked: false,
          enabled: false,
        },
      ]);
    }
  }, [selectedlecture]);
  const MarkedLectureDiv = () => (
    <DivMarked screen={screen}>
      <div>
        Topics marked in {selectedlecture?.eventName} |{" "}
        {convertTime(selectedlecture?.startTime, "D MMM YY")}
      </div>
      {["xs", "sm", "md"].includes(screen) ? null : (
        <CloseIcon
          className="cursorHoverCSS"
          onClick={() => {
            setIsLectureViewModal(!isLectureViewModal);
          }}
        ></CloseIcon>
      )}
    </DivMarked>
  );
  const Toggle = () => {
    setIsLectureViewModal(!isLectureViewModal);
  };
  return (
    <>
      {["xs", "sm", "md"].includes(screen) ? (
        <SliderPaneComponent
          isPaneOpen={isLectureViewModal}
          header={
            <div className="d-flex justify-content-between">
              <div className="d-flex">
                <LeftArrow className={"cursorHoverCSS mr-1"} onClick={Toggle} />
                <MarkedLectureDiv />
              </div>
            </div>
          }
          bodyClassName={"bodyClassName"}
          onRequestClose={Toggle}
        >
          <MarkedLectureViewListing
            Loader={Loader}
            data={lectureAssetsData}
          ></MarkedLectureViewListing>
          <div className="filterFooter p-0">
            {["myScheduled"].includes(mode) ? (
              <Button
                color={"aeslPrimary footerAddCommentBtn"}
                className="d-flex justify-content-center w-100"
                onClick={() => {
                  Toggle();
                  editHandler(lectureAssetsData);
                }}
              >
                Edit
              </Button>
            ) : null}
          </div>
        </SliderPaneComponent>
      ) : (
        <Modal
          isOpen={isLectureViewModal}
          centered={true}
          backdrop={true}
          size={"lg"}
          fullscreen={true}
          toggle={Toggle}
          className={
            ["xs", "sm", "md"].includes(screen)
              ? "syllabusModal"
              : "syllabusModalDK"
          }
        >
          <div
            className={
              ["xs", "sm", "md"].includes(screen)
                ? "markedLectureViewModalBodyMB"
                : "markedLectureViewModalBody"
            }
          >
            <MarkedLectureDiv />

            <MarkedLectureViewListing
              Loader={Loader}
              data={lectureAssetsData}
            ></MarkedLectureViewListing>
          </div>
          <ModalFooter>
            <div className="mt-1 d-flex flex-row">
              {["myScheduled"].includes(mode) ? (
                <Button
                  color={"aeslPrimary"}
                  onClick={() => {
                    Toggle();
                    editHandler(lectureAssetsData);
                  }}
                >
                  Edit
                </Button>
              ) : null}
            </div>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
};
export default MarkedLectureViewModal;
